import { Route, Routes } from 'react-router-dom'
import { HomePage } from './Home/Home'
import { Profile } from './Profile/Profile'
import { QuestionDetailsPage } from './QuestionDetails/QuestionDetails'
import { InterviewsPage } from './Interviews/InterviewsPage'
import { AdminPage } from './Admin/AdminPage'
import { AdminUsersPage } from './AdminUsers/AdminUsersPage'
import { AdminSubscriptionsPage } from './AdminSubscriptions/AdminSubscriptionsPage'
import { AdminDirectionsPage } from './AdminDirections/AdminDirectionsPage'
import { AdminTagsPage } from './AdminTags/AdminTagsPage'
import { AdminAnalyticsPage } from './AdminAnalytics/AdminAnalyticsPage'

export const MainPage = () => {
    return(
        <Routes>
            <Route index element={<HomePage />} />
            <Route path="questions/:questionId" element={<QuestionDetailsPage />} />
            <Route path="interviews" element={<InterviewsPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="admin/users" element={<AdminUsersPage />} />
            <Route path="admin/subscriptions" element={<AdminSubscriptionsPage />} />
            <Route path="admin/directions" element={<AdminDirectionsPage />} />
            <Route path="admin/tags" element={<AdminTagsPage />} />
            <Route path="admin/analytics" element={<AdminAnalyticsPage />} />
            <Route path="profile" element={<Profile />} />
        </Routes>
    )
}
